module.exports = __webpack_public_path__ + "img/12_andy_n.0d50d15e.png";